import React from "react";
import SizeGuidePopup from "./modals/sizeGuidePopup";
import CartSuccessPopup from "../Cart/cartSuccessPopup";
import icons from "../../icons.config";
import {useNavigate} from 'react-router-dom';
import FAQsSection from './faqsSection';

const ProductDetails = ({
  product, quantity, setQuantity, selectedSize, handleSizeSelection, isSizeGuideOpen,
  toggleSizeGuide, variantId, selectedColor, handleColorSelection, buttonText, handleAddToCart,
  handleLike, showCartSuccessPopup, setShowCartSuccessPopup, setIsCustomModalOpen, faqs, activeIndex, toggleFAQ,isAuthenticated
}) =>{
  const navigate = useNavigate(); // Hook for navigation

  // Handler for custom size button click
  const handleCustomSizeClick = () => {
    // Check if the user is authenticated
    if (isAuthenticated) {
      setIsCustomModalOpen(true); // Open the modal if authenticated
    } else {
      navigate("/login"); // Redirect to login if not authenticated
    }
  };
  return (
  <div className="relative top-10 lg:left-6 px-2 lg:px-9 overflow-y-auto min-h-screen">
    <h1 className="text-2xl lg:text-3xl xl:text-4xl font-outfit font-light">{product?.data?.product_name}</h1>
    <p className="text-secondary text-base lg:text-lg xl:text-xl font-outfit font-light">{product?.data?.selectedVariant.title}</p>
    <p className="text-hcolor font-outfit my-1">Material: {product?.data?.selectedVariant.dress_material}</p>
    <div className="lg:space-y-2 xl:space-y-11 2xl:space-y-7">
      <h2 className="text-xl font-semibold flex justify-start items-center my-7">
        <span className="lg:text-lg xl:text-xl text-primary1 line-through mr-6">Rs. {product?.data?.selectedVariant.price}</span>
        <span className="lg:text-lg xl:text-xl text-hcolor">Rs. {product?.data?.selectedVariant.discount_price}</span>
      </h2>
      <div className="border border-primary2 my-8"></div>
      <div>
        <div className="flex justify-between">
          <h3 className="text-sm font-normal font-outfit mb-4 text-primary1">SIZE</h3>
          <SizeGuidePopup showTrigger={true} isOpen={isSizeGuideOpen} togglePopup={toggleSizeGuide} variantId={variantId} />
        </div>
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 gap-x-6 lg:pr-3 lg:pt-3 2xl:pt-0">
          {product?.data?.selectedVariant.sizes.map((size, index) => (
            <button
              key={index}
              className={`py-1 px-0 text-hcolor hover:bg-hcolor hover:text-tertiary border border-hcolor ${
                selectedSize === size.size_name ? "bg-hcolor text-tertiary border border-secondary" : ""
              }`}
              onClick={() => handleSizeSelection(size.size_name)}
            >
              {size.size_name}
            </button>
          ))}
        </div>
        <button
          className="mb-4 mt-5 lg:mt-6 2xl:mt-4 px-6 md:px-16 lg:px-6 py-2 border border-hcolor bg-hcolor text-tertiary hover:bg-secondary hover:text-hcolor"
          onClick={handleCustomSizeClick} // Use the new handler
        >
          CUSTOM SIZE
        </button>
      </div>
      <div className="flex flex-col lg:flex-row gap-5 lg:gap-20 lg:my-2 2xl:my-3">
        <div>
          <h3 className="text-lg font-normal font-outfit mb-2">Quantity</h3>
          <div className="flex items-center space-x-4 mt-2">
            <button
              onClick={() => setQuantity((prev) => Math.max(prev - 1, 1))}
              className="px-4 py-5 bg-tertiary text-hcolor font-bold hover:bg-primary2 focus:outline-none border border-secondary"
              aria-label="Decrease Quantity"
            >
              <img src={icons.decreaseQ} alt="decrease quantity" />
            </button>
            <span className="text-2xl font-light font-outfit text-hcolor">{quantity}</span>
            <button
              onClick={() => setQuantity((prev) => prev + 1)}
              className="px-4 py-4 bg-tertiary text-hcolor font-bold hover:bg-primary2 focus:outline-none border border-secondary"
              aria-label="Increase Quantity"
            >
              <img src={icons.increaseQ} alt="increase quantity" />
            </button>
          </div>
        </div>
        <div>
          <h3 className="text-lg font-normal font-outfit mb-2">Color</h3>
          <div className="flex gap-3">
            {product?.data?.colors?.map((color, index) => (
              <div
                key={index}
                onClick={() => handleColorSelection(color)}
                className={`w-10 h-10 rounded-full border-4 cursor-pointer ${
                  selectedColor === color.color_code ? "border-primary" : "border-secondary"
                }`}
                style={{ backgroundColor: color.color_code }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-4 my-11">
        <button
          className="flex-1 px-5 py-2 bg-tertiary text-hcolor hover:bg-hcolor hover:text-tertiary border-2 border-hcolor"
          onClick={handleAddToCart}
        >
          {buttonText}
        </button>
        {showCartSuccessPopup && (
          <CartSuccessPopup message="Item added to cart successfully!" onClose={() => setShowCartSuccessPopup(false)} />
        )}
        <button
          className="flex-1 px-5 py-2 border-2 border-hcolor bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor"
          onClick={() => handleLike(variantId)}
        >
          ADD TO WISHLIST
        </button>
      </div>
      <div>
        <h3 className="text-lg text-primary1 mb-2 font-normal font-poppins my-4">About this dress</h3>
        <p className="text-hcolor font-poppins text-sm font-extralight">
          {product?.data?.info ? product.data.info.split(/\r?\n/).map((line, index) => <div key={index}>{line}</div>) : "No information available"}
        </p>
      </div>
      <FAQsSection faqs={faqs} activeIndex={activeIndex} toggleFAQ={toggleFAQ} />
    </div>
  </div>
);
}

export default ProductDetails;